import { useQuery } from '@tanstack/react-query';
import { listEpisodeFiles, scanEpisodeFile } from '../api/episodeDbScan';

/**
 * The team's own uploaded recordings in a date range. `enabled` lets the
 * list page leave this idle while an admin is looking at every team's files
 * through the admin list instead.
 */
export const useTeamEpisodeFiles = (from: string, to: string, enabled = true) =>
  useQuery({
    queryKey: ['episode-db-scan', 'files', from, to],
    queryFn: () => listEpisodeFiles(from, to),
    enabled: enabled && Boolean(from && to),
  });

/**
 * One file's runs cross-checked against the server. It runs as soon as the
 * file is opened, and after that only when asked (refetch): the first scan of
 * a file downloads it server-side, so it should not fire again just because
 * the window regained focus, and a refusal (a file that is not the team's) is
 * an answer rather than something to retry.
 */
export const useEpisodeFileScan = (s3Key: string | undefined) =>
  useQuery({
    queryKey: ['episode-db-scan', 'file', s3Key],
    queryFn: () => scanEpisodeFile(s3Key as string),
    enabled: Boolean(s3Key),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
